import { render, staticRenderFns } from "./yysd-table.vue?vue&type=template&id=d101d052&scoped=true"
import script from "./yysd-table.vue?vue&type=script&lang=js"
export * from "./yysd-table.vue?vue&type=script&lang=js"
import style0 from "./yysd-table.vue?vue&type=style&index=0&id=d101d052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d101d052",
  null
  
)

export default component.exports